import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import 'balloon-css/balloon.min.css'
import TranslationProvider from 'decentraland-dapps/dist/providers/TranslationProvider'
import WalletProvider from 'decentraland-dapps/dist/providers/WalletProvider'
import { DclThemeProvider, lightTheme } from 'decentraland-ui2'
import 'decentraland-ui/dist/themes/alternative/light-theme.css'
import 'decentraland-ui/dist/themes/base-theme.css'
import 'decentraland-ui/lib/styles.css'
import 'semantic-ui-css/semantic.min.css'

import Layout from './components/Layout/Layout'
import { initStore } from './modules/store'

import IndexPage from './pages'
import './theme.css'

const queryClient = new QueryClient()
const basename = /^decentraland.(zone|org|today)$/.test(window.location.host) ? '/dao' : '/'

const root = createRoot(document.getElementById('root')!)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename}>
        <Provider store={initStore()}>
          <WalletProvider>
            <DclThemeProvider theme={lightTheme}>
              <TranslationProvider locales={['en']}>
                <Layout>
                  <Switch>
                    <Route path="*" component={IndexPage} />
                  </Switch>
                </Layout>
              </TranslationProvider>
            </DclThemeProvider>
          </WalletProvider>
        </Provider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
